import request from "@/utils/request";

export const putInfomationUplate = (data, params) => {
  return request({
    url: "/api/pub/user/update",
    method: "PUT",
    data: data,
    params: params,
  });
};

export const getCollectionPage = (params) => {
  return request({
    url: "/api/pub/user/collect/list",
    headers: { "X-TO": "1" },
    method: "GET",
    params: params,
  });
};

// 学习课程
export const getLeargingCourse = (params) => {
  return request({
    url: "/api/cqooc/student/my/course/list",
    method: "GET",
    params: params,
  });
};

// 获取体测记录
export const getPhyRecords = (params) => {
  return request({
    url: "/api/sports/report/measure/list",
    headers: { "X-TO": "1" },
    method: "GET",
    params: params,
  });
};

// 获取科普参赛活动
export const getKepuAct = (params) => {
  return request({
    url: "/api/stem/home/match/list",
    headers: { "X-TO": "1" },
    method: "GET",
    params: params,
  });
};

// 获取科普赛项
export const getKepuItem = (params) => {
  return request({
    url: "/api/stem/home/category/list",
    method: "GET",
    headers: { "X-TO": "1" },
    params: params,
  });
};

// 获取科普列表
export const getKepuPage = (params) => {
  return request({
    url: "/api/stem/user/project",
    method: "GET",
    headers: { "X-TO": "1" },
    params: params,
  });
};

// 手机号验证
export const postPasswordCheck = (data) => {
  return request({
    url: "/api/pub/auth/forget/sms/check",
    method: "POST",
    data: data,
  });
};

// 编辑密码
export const postEditPassword = (data) => {
  return request({
    url: "/api/pub/auth/forget/sms/password",
    method: "POST",
    data: data,
  });
};

// 发送更改密码手机号
export const postSendForgetCode = (params) => {
  return request({
    url: "/api/pub/auth/forget/sms/send",
    method: "POST",
    params: params,
  });
};

// 孩子管理部分

// 查询孩子列表
export const getChild = (params) => {
  return request({
    url: "/api/pub/children/list",
    method: "GET",
    headers: { "X-TO": "1" },
    params: params,
  });
};

// 添加孩子
export const postChild = (data) => {
  return request({
    url: "/api/pub/children/add",
    method: "POST",
    data: data,
  });
};

// 绑定孩子
export const postBindChild = (data) => {
  return request({
    url: "/api/pub/children/bind",
    method: "POST",
    data: data,
  });
};

// 家庭成员
export const getChildMembers = (params) => {
  return request({
    url: "/api/pub/children/familyMembers",
    method: "GET",
    headers: { "X-TO": "1" },
    params: params,
  });
};

// 查询是否存在孩子
export const postChildExist = (data) => {
  return request({
    url: "/api/pub/children/getHasChildByAddInfo",
    method: "POST",
    data: data,
  });
};

// 获取孩子的管理员家长手机号
export const getChildParentPhone = (params) => {
  return request({
    url: "/api/pub/children/getManagementPhone",
    method: "GET",
    headers: { "X-TO": "1" },
    params: params,
  });
};

export const putChild = (data, params) => {
  return request({
    url: "/api/pub/children/update",
    method: "POST",
    data: data,
    params: params,
  });
};

export const getCheckPhone = (params) => {
  return request({
    url: "/api/pub/children/verifyPhone",
    method: "GET",
    headers: { "X-TO": "1" },
    params: params,
  });
};

// 班级相关接口

// 班级新增
export const postAddClass = (data) => {
  return request({
    url: "/api/pub/classesManage/add",
    method: "POST",
    data: data,
  });
};

// 班级删除
export const deleteClass = (params) => {
  return request({
    url: "/api/pub/classesManage/delete",
    method: "DELETE",
    params: params,
  });
};

// 班级详情
export const getClassDetail = (params) => {
  return request({
    url: "/api/pub/classesManage/detail",
    method: "GET",
    headers: { "X-TO": "1" },
    params: params,
  });
};

// 退出班级
export const postExitClass = (data) => {
  return request({
    url: "/api/pub/classesManage/exitClass",
    method: "POST",
    data: data,
  });
};

// 退出班级-教师
export const postExitClassTeacher = (data) => {
  return request({
    url: "/api/pub/classesManage/teacherExitClass",
    method: "POST",
    data: data,
  });
};

// 加入班级
export const postJoinClass = (data) => {
  return request({
    url: "/api/pub/classesManage/joinClass",
    method: "POST",
    data: data,
  });
};

// 班级列表-查询教师下班级
export const getTeacherClass = (params) => {
  return request({
    url: "/api/pub/classesManage/listByTeacher",
    method: "GET",
    headers: { "X-TO": "1" },
    params: params,
  });
};

// 班级列表-根据用户id查询
export const getUserClass = (params) => {
  return request({
    url: "/api/pub/classesManage/listByUserId",
    method: "GET",
    params: params,
  });
};

// 班级成员列表
export const getClassMember = (params) => {
  return request({
    url: "/api/pub/classesManage/memberList",
    method: "GET",
    params: params,
  });
};

// 移除用户
export const deleteClassMember = (data) => {
  return request({
    url: "/api/pub/classesManage/removeMember",
    method: "POST",
    data: data,
  });
};

// 班级修改
export const putClass = (data, params) => {
  return request({
    url: "/api/pub/classesManage/update",
    method: "PUT",
    data: data,
    params: params,
  });
};

// 获取工具集收藏列表
export const getToolsCollection = (params) => {
  return request({
    url: "/api/person/tools/page",
    method: "GET",
    params: params,
  });
};

// 收藏-添加
export const postCollectTool = (params) => {
  return request({
    url: "/api/person/tools/add",
    method: "POST",
    params: params,
  });
};

// 收藏-取消
export const postCancelCollectTool = (params) => {
  return request({
    url: "/api/person/tools/remove",
    method: "POST",
    params: params,
  });
};
